module.exports = __webpack_public_path__ + "assets/img/1608.67a642f2.svg";